import Choices from 'choices.js';

import loadScript from '../functions/script-loader.js';
import loadStyleSheet from '../functions/styles-loader.js';


export const moduleFuseFeed = () => {


	let fuseFeedModules = document.querySelectorAll('.m__fuse-feed');
	if(fuseFeedModules){

		let hasLoadedjQueryAlready = false;

		fuseFeedModules.forEach((module) => {
			const dateFilterEl = module.querySelector('#dateFilter'),
			locationFilterEl = module.querySelector('#locationFilter'),
			fuseEventCards = module.querySelectorAll('.js__spaces-card'),
			resetFilters = module.querySelectorAll('.js__reset-filters'),
			fuseEventCardsGrid = module.querySelector('.m__fuse-feed__grid'),
			noSpacesFoundMessage = module.querySelector('.m__fuse-feed__none-found'),
			loadMoreButton = module.querySelector('.js__load-more-spaces');
			
			let dateFilterStartDate	= 0,
				dateFilterEndDate   = 0;


			if(dateFilterEl && locationFilterEl){

				//Init nice styled dropdown
				const choicesConfig = {
					itemSelectText: '',
					shouldSort: false,
					searchEnabled: false,
				},
				locationFilter = new Choices(locationFilterEl,choicesConfig);

				//Init nice datepicker
				if(!hasLoadedjQueryAlready){
					//Dynamically load in jQuery, and daterangepicker. All shamelessly taken from Drake & Morgan
					loadScript('https://cdn.jsdelivr.net/jquery/latest/jquery.min.js',() => {
						loadScript('https://cdn.jsdelivr.net/momentjs/latest/moment.min.js',() => {
							loadScript('https://cdn.jsdelivr.net/npm/daterangepicker/daterangepicker.min.js',() => {
								loadStyleSheet('https://cdn.jsdelivr.net/npm/daterangepicker/daterangepicker.css').then(() =>{
									//Activate DateRangePicker
									var date = new Date();
									var d = date.getDate();
									var m = date.getMonth()+1;
									var y = date.getFullYear();
									var y2 = y + 2;
									var mindate = d+'/'+m+'/'+y;
									var maxdate = d+'/'+m+'/'+y2;
									
									$('#dateFilter').daterangepicker({
										opens: 'left',
										autoUpdateInput: false,
										minDate: mindate,
										maxDate: maxdate,
										ranges: {
									      'This Week': [moment().startOf('week'), moment().endOf('week').add(1, 'days')],
									      'This Month': [moment().startOf('month'), moment().endOf('month')],
									  },
									  alwaysShowCalendars: true,
										locale: {
									    format: 'DD/MM/YYYY'
									  }
									}, (start, end, label) => { //On select event
										//Update element with selected dates
										dateFilterEl.value = (start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));

										dateFilterStartDate = start.unix();
										dateFilterEndDate   = end.unix();
 
										dateFilterEl.dispatchEvent(new Event('change'));
									} ); 
								})
							})
						})

					})
				}


				//Select elements for us to watch for changes
				let filterInputs = [
					dateFilterEl,
					locationFilterEl
				];
				filterInputs.forEach((filterInput) =>{

					filterInput.addEventListener("change", (event) => {

						loadMoreButton.parentElement.classList.add('hidden');

						let currentDateFilter = dateFilterEl.value,
							currentLocationFilter = locationFilterEl.value,
							hiddenCardCount = 0;				

						//Reset no spaces found message
						fuseEventCardsGrid.classList.remove('ig-hidden');
						noSpacesFoundMessage.classList.add('hidden');

						fuseEventCards.forEach((card) => {

							card.classList.remove('hidden');
							const locationArr = JSON.parse(card.dataset.locations);
							const matchesLocation = locationArr.some(item => currentLocationFilter.includes(item));

							//Check if event is in search range

							let cardDate = parseInt(card.dataset.date);

							if((dateFilterStartDate > 0 || dateFilterEndDate > 0) && (cardDate < dateFilterStartDate || cardDate > dateFilterEndDate) ){ //Filter out any that don't meet the date filter
								card.classList.add('hidden');
								hiddenCardCount++;
							
							}else if(currentLocationFilter != 0 && !matchesLocation){ //"" with Locations filter
								card.classList.add('hidden');
								hiddenCardCount++;
							}

						});

						//Show the no spaces found message
						if(hiddenCardCount == fuseEventCards.length){
							fuseEventCardsGrid.classList.add('ig-hidden');
							noSpacesFoundMessage.classList.remove('hidden');
						}


						//Manage reset filters button state
						if(currentLocationFilter != 0 || currentDateFilter > ''){
							resetFilters.forEach((resetFilter)=>{
								resetFilter.classList.remove('active');
							});
						}else{
							resetFilters.forEach((resetFilter)=>{
								resetFilter.classList.add('active');
							});
						}
						

						

					});
				})

				//Add listeners for any clicks on a reset filter class
				resetFilters.forEach((resetFilter)=>{
					resetFilter.addEventListener('click', (event) => {

						event.target.classList.add('active');

						fuseEventCardsGrid.classList.remove('ig-hidden');
						noSpacesFoundMessage.classList.add('hidden');

						dateFilterStartDate	= 0,
						dateFilterEndDate   = 0;

						dateFilter.value = '';
						locationFilter.setChoiceByValue('0');

						let x = 0;
						fuseEventCards.forEach((card) => {
							if(x <= 9){
								card.classList.remove('hidden');
							}
							x++;
						});
					})
				})

				//Add listener for load more button click
				loadMoreButton.addEventListener('click',(event) => {
					let currentDateFilter = dateFilterEl.value,
						currentLocationFilter = locationFilterEl.value;	

					fuseEventCards.forEach((card) => {
						const brandArr = JSON.parse(card.dataset.locations);
						const matchesLocation = brandArr.some(item => currentLocationFilter.includes(item));

						let cardDate = parseInt(card.dataset.date);

						if((dateFilterStartDate <= 0 || dateFilterEndDate <= 0) || (cardDate < dateFilterStartDate || cardDate > dateFilterEndDate) ){ //Filter out any that don't meet the date filter
							card.classList.remove('hidden');
						}else if(currentLocationFilter == 0 || matchesBrand){
							card.classList.remove('hidden');
						}
					});
					event.target.parentElement.classList.add('hidden');
				})
			}
		})
		
	}
	
}








